import { render } from "./AppMultiplication.vue?vue&type=template&id=f1849d92"
import script from "./AppMultiplication.vue?vue&type=script&lang=js"
export * from "./AppMultiplication.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__